import React, { useRef, useState, useEffect } from 'react'
import { shuffleWithElement } from '../utils/SmartLabelUtils'
import { LabelSelect } from './LabelSelect'
import { getNonRepeatingFeedback } from '../utils/FeedbackUtils'

function SmartLabelSelect(props) {
  const {
    ActivityJson,
    Completed,
    ContentID,
    isPractice,
    Status,
    smartLabelExercise
  } = props //Common values to mode screen

  const {
    seconds,
    minutes,
    modesWorkData,
    isImageLoaded,
    isActive,
    isVerifyMode,
    explanationClick,
    resetClick,
    isBgAudioPlayed,
    FollowTheFlow,
    isAudioPlaying,
    isPreview
  } = props //Values to mode screen
  const { setWorkJson } = props //from dispatch
  const {
    getAttempts,
    getAttemptsPractice,
    getCoordinateArray,
    getCurrentScore,
    getCurrentScoreApi,
    getCurrentScoreReset,
    getCumulativeAverageScoreOld,
    getTotalResetOld,
    getResetDataValue,
    getTotalResetPractice,
    getPriorityCount,
    handleExplanationChange,
    clearReset,
    getValidationFeedback,
    getFeedbackData
  } = props //Values to base screen

  const [coordinateArray, setCoordinateArray] = useState([])
  const [currentScore, setCurrentScore] = useState(0)
  const [attempts, setAttempts] = useState(0)
  const [resetValue, setresetValue] = useState(0)
  const [priorityActive, setPriorityActive] = useState(0)
  const [showNavToast, setShowNavToast] = useState(false)
  const [attemptsPractice, setAttemptsPractice] = useState(0)
  const [totalResetPractice, setTotalResetPractice] = useState(0)

  const [currentScoreApi, setCurrentScoreApi] = useState(0)
  const [currentScoreReset, setCurrentScoreReset] = useState(0)

  const [cumulativeAverageScoreOld, setCumulativeAverageScoreOld] = useState(0)
  const [totalResetOld, setTotalResetOld] = useState(0)
  const [selectedBox, setSelectedBox] = useState(undefined)

  useEffect(() => {
    const exercise = JSON.parse(ActivityJson)
    setCoordinateArray(
      exercise.SmartLabelBoxes.map((obj) => ({
        ...obj,
        defaultValue: '',
        elapsedTime: '',
        Rotation: obj.Rotation.toString().concat('deg')
      }))
    )
  }, [])

  useEffect(() => {
    if (isBgAudioPlayed) {
      const exercise = JSON.parse(ActivityJson)
      window.speechSynthesis.cancel()
      const workJsonCopy = [...modesWorkData]
      const index = workJsonCopy.findIndex(
        (element) => element.isResetDone === 1
      )
      if (index >= 0) {
        setresetValue(1)
      }
      if (!isPreview) {
        if (Status.toLowerCase() === 'rework' && index < 0) {
          setresetValue(0)
        }
      }

      let condition =
        modesWorkData.length > 0 &&
        modesWorkData.filter(
          (e) => e.ContentID === ContentID && e.ModeName === 'Select'
        ).length > 0

      if (condition) {
        let indexOfType = modesWorkData.findIndex(
          (obj) => obj.ContentID === ContentID && obj.ModeName === 'Select'
        )
        const workJson = modesWorkData[indexOfType]
        setCurrentScore(workJson.Score)
        setCurrentScoreReset(workJson.ResetScore ? workJson.ResetScore : 0)
        setAttempts(workJson.AttemptsOverall ? workJson.AttemptsOverall : 0)
        if (Completed === 0) {
          setPriorityActive(workJson.priorityCount ? workJson.priorityCount : 1)
        } else {
          setPriorityActive(exercise.SmartLabelBoxes.length)
        }
        if (workJson.listControls.length > 0) {
          let modifiedArray = exercise.SmartLabelBoxes.map((c, index) => {
            c.defaultValue = workJson.listControls[index].CtlValue
            c.elapsedTime = workJson.listControls[index].elapsedTime
            c.Rotation = c.Rotation.toString().concat('deg')
            return c
          })
          setCoordinateArray(modifiedArray)
        } else {
          setCoordinateArray(
            exercise.SmartLabelBoxes.map((obj) => ({
              ...obj,
              defaultValue: '',
              elapsedTime: '',
              Rotation: obj.Rotation.toString().concat('deg')
            }))
          )
        }

        setAttemptsPractice(workJson.Attempts)
        setTotalResetPractice(
          workJson.TotalResetPractice ? workJson.TotalResetPractice : 0
        )
        setCumulativeAverageScoreOld(
          workJson.CumulativeAverageScoreOld
            ? workJson.CumulativeAverageScoreOld
            : 0
        )
        setTotalResetOld(workJson.TotalResetOld ? workJson.TotalResetOld : 0)
      } else {
        if (Completed === 0) {
          setPriorityActive(1)
        } else {
          setPriorityActive(exercise.SmartLabelBoxes.length)
        }
        setCoordinateArray(
          exercise.SmartLabelBoxes.map((obj) => ({
            ...obj,
            defaultValue: '',
            elapsedTime: '',
            Rotation: obj.Rotation.toString().concat('deg')
          }))
        )
      }
    }
  }, [isBgAudioPlayed, modesWorkData])

  useEffect(() => {
    if (FollowTheFlow) {
      setShowNavToast(true)
      setTimeout(() => {
        setShowNavToast(false)
      }, 2000)
    }
  }, [])

  const [optionsArray, setOptionsArray] = useState([])
  useEffect(() => {
    if (coordinateArray.length > 0 && optionsArray.length === 0) {
      let tempArray = []
      coordinateArray.forEach((element, index) => {
        let tempOptions = shuffleWithElement(coordinateArray, element)
        tempArray.push(tempOptions)
      })
      setOptionsArray(tempArray)
    }
  }, [coordinateArray])

  useEffect(() => {
    let score = 0
    coordinateArray.forEach((item) => {
      if (item.defaultValue === item.CorrectAnswer) {
        score += item.Weight
      }
    })
    setCurrentScore(score)
    let modifyCurrentScore = scoreForPractice()
    setCurrentScoreApi(currentScoreReset + modifyCurrentScore)
  }, [attempts])

  let isBackButtonClicked = false

  const onBackButtonEvent = (event) => {
    event.preventDefault()
    if (!isBackButtonClicked) {
      isBackButtonClicked = true
    }
  }
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', onBackButtonEvent)
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent)
    }
  }, [])

  function funcReset() {
    const exercise = JSON.parse(ActivityJson)
    setAttempts(0)
    setCurrentScore(0)
    setOptionsArray([])
    setCoordinateArray(
      exercise.SmartLabelBoxes.map((obj) => ({
        ...obj,
        defaultValue: '',
        elapsedTime: '',
        Rotation: obj.Rotation.toString().concat('deg')
      }))
    )
    setWorkJson(JSON.stringify([]))
    setresetValue(1)
    clearReset()
  }

  function funcResetPractice() {
    const exercise = JSON.parse(ActivityJson)
    let calculateScAt = calculateTotalComponents()
    let modifyCurrentScore = 0
    if (calculateScAt < 1) {
      let modifyScore = Math.round(currentScore * calculateScAt)
      modifyCurrentScore = modifyScore
    } else {
      modifyCurrentScore = currentScore
    }
    setCurrentScoreReset(
      (currentScoreReset) => currentScoreReset + modifyCurrentScore
    )
    setOptionsArray([])
    setCoordinateArray(
      exercise.SmartLabelBoxes.map((obj) => ({
        ...obj,
        defaultValue: '',
        elapsedTime: '',
        Rotation: obj.Rotation.toString().concat('deg')
      }))
    )
    setPriorityActive(1)
    setAttemptsPractice(0)
    let tempScoreAverage =
      (currentScoreApi /
        ((totalResetPractice + 1) * smartLabelExercise.TotalWeight)) *
      100
    setCumulativeAverageScoreOld(tempScoreAverage)
    setTotalResetOld(totalResetPractice + 1)
    setTotalResetPractice((totalResetPractice) => totalResetPractice + 1)
    setCurrentScore(0)
    clearReset()
  }

  useEffect(() => {
    getAttempts(attempts)
  }, [attempts])
  useEffect(() => {
    getAttemptsPractice(attemptsPractice)
  }, [attemptsPractice])
  useEffect(() => {
    getCurrentScore(currentScore)
  }, [currentScore])
  useEffect(() => {
    getCurrentScoreApi(currentScoreApi)
  }, [currentScoreApi])
  useEffect(() => {
    getCurrentScoreReset(0)
  }, [currentScoreReset])
  useEffect(() => {
    getCumulativeAverageScoreOld(cumulativeAverageScoreOld)
  }, [cumulativeAverageScoreOld])
  useEffect(() => {
    getTotalResetOld(totalResetOld)
  }, [totalResetOld])
  useEffect(() => {
    getCoordinateArray(coordinateArray)
  }, [coordinateArray])
  useEffect(() => {
    getTotalResetPractice(totalResetPractice)
  }, [totalResetPractice])
  useEffect(() => {
    getPriorityCount(priorityActive)
  }, [priorityActive])
  useEffect(() => {
    getResetDataValue(resetValue)
  }, [resetValue])
  useEffect(() => {
    if (resetClick === 'resetPractice') {
      funcResetPractice()
    } else if (resetClick === 'resetTest') {
      funcReset()
    }
  }, [resetClick])

  function onOptionSelect(
    selectedValue,
    correctAnswer,
    selectedIndex,
    Priority
  ) {
    if (FollowTheFlow && !isPractice) {
      if (Priority >= priorityActive) {
        setPriorityActive(priorityActive + 1)
      }
    }

    //Find answered component feedbackdata
    const currentLabel = smartLabelExercise.SmartLabelBoxes[selectedIndex]
    const currentFeedbackData = currentLabel.FeedbackAudioData
    //Get success feedback data
    const currentLabelSuccessData = currentFeedbackData.successData
    //Get failure feedback or hint randomly
    const currentFailureFeedbackData = currentFeedbackData.failureData
    const currentLabelFailureData = getNonRepeatingFeedback(
      selectedIndex,
      currentFailureFeedbackData
    )

    if (selectedValue === correctAnswer) {
      if (FollowTheFlow && isPractice) {
        if (Priority >= priorityActive) {
          setPriorityActive(priorityActive + 1)
        }
      }
      if (isPractice) {
        getValidationFeedback('success', true)
        if (
          currentLabelSuccessData.successAudioLink &&
          currentLabelSuccessData.successAudioLink !== ''
        ) {
          getFeedbackData(
            currentLabelSuccessData.successFeedback,
            currentLabelSuccessData.successAudioLink,
            'success'
          )
        }
      }
    } else {
      if (isPractice) {
        getValidationFeedback('failure', true)
        if (
          currentLabelFailureData.failureAudioLink &&
          currentLabelFailureData.failureAudioLink !== ''
        ) {
          getFeedbackData(
            currentLabelFailureData.failureFeedback,
            currentLabelFailureData.failureAudioLink,
            'failure'
          )
        }
      }
    }

    let modifiedCoordinateArray = [...coordinateArray]
    modifiedCoordinateArray[selectedIndex].defaultValue = selectedValue
    modifiedCoordinateArray[selectedIndex].elapsedTime = minutes + ':' + seconds
    setCoordinateArray(modifiedCoordinateArray)
    setAttempts((attempts) => attempts + 1)
    setAttemptsPractice((attempts) => attempts + 1)
  }

  function scoreForPractice() {
    let modifyCurrentScore = 0
    let calculateScAt = calculateTotalComponents()
    if (calculateScAt < 1) {
      let modifyScore = Math.round(currentScore * calculateScAt)
      modifyCurrentScore = modifyScore
    } else {
      modifyCurrentScore = currentScore
    }
    return modifyCurrentScore
  }

  function calculateTotalComponents() {
    const exercise = JSON.parse(ActivityJson)
    let noOfComponents = exercise.SmartLabelBoxes.length
    let calculateScAt = 0
    if (attemptsPractice !== 0) {
      calculateScAt = noOfComponents / attemptsPractice
    }
    return calculateScAt
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {isImageLoaded && smartLabelExercise.BackgroundImage !== '' && (
        <LabelSelect
          smartLabelExercise={smartLabelExercise}
          FollowTheFlow={FollowTheFlow}
          coordinateArray={coordinateArray}
          isVerifyMode={isVerifyMode}
          isPractice={isPractice}
          Completed={Completed}
          isActive={isActive}
          priorityActive={priorityActive}
          explanationClick={explanationClick}
          optionsArray={optionsArray}
          screenMode={'desktop'}
          isImageLoaded={isImageLoaded}
          handleExplanationChange={(statusFromParent, textFromParent) => {
            handleExplanationChange(statusFromParent, textFromParent)
          }}
          onOptionSelect={(value, correctAnswer, index, priority) => {
            onOptionSelect(value, correctAnswer, index, priority)
          }}
          setSelectedBox={(selectedBoxFromParent) => {}}
          projectName={'backpackweb'}
          isAudioPlaying={isAudioPlaying}
        />
      )}
    </div>
  )
}

export { SmartLabelSelect }
